import { useDataGrid } from "../../../core/components/data-grid/DataGridContext";
import { useModal } from "../../../core/context/ModalContext";
import React, { useEffect, useState } from "react";
import { t } from "i18next";
import Helper from "../../../core/Helper";
import ApiService from "../../../core/service/ApiService";
import { Table, Typography } from "antd";
import PaymentSummary from "../appointment-datagrid/PaymentSummary";
import { useUser } from "../../../core/context/UserContext";


const { Text } = Typography;

export const PatientSummaryRow = ({ colSpan = 6 }) => {
    const { queryModel, resultModel } = useDataGrid();
    const { openModal } = useModal();
    const { formatPrice } = useUser();
    const [summary, setSummary] = useState({
        appointmentSummaries: [],
        entitlementSummary: []
    });

    const openPaymentSummaryByMethod = () => {
        openModal(t('Summary'), (
            <PaymentSummary
                data={summary}
            />
        ))
    }

    const get = async () => {
        const input = {
            ...queryModel.filter,
            startDate: Helper.Date.beginOfDay(queryModel.filter.startDate),
            endDate: Helper.Date.endOfDay(queryModel.filter.endDate),
            requirePatientId: true,
        }

        const res2 = await ApiService.Appointment.GetAppointmentDataGridSummary(input);
        if (res2.success) {
            setSummary(res2.data)
        }
    }

    useEffect(() => {
        const total = resultModel?.pagination?.totalRecords;
        if (!queryModel.filter?.patientId || !total) {
            setSummary({ appointmentSummaries: [], entitlementSummary: [] });
            return;
        }
        get();
    }, [queryModel.updateKey, resultModel?.pagination?.totalRecords])

    if (!summary?.appointmentSummaries || summary.appointmentSummaries.length === 0) {
        return null;
    }

    // Tek hücre, tüm satırı kaplar: Toplam / Ödenen / Kalan Borç alt alta (para birimi başına bir blok).
    // İki sütunlu grid: etiketler solda, tutarlar sağa hizalı. Renk yalnızca Kalan Borç'ta.
    return (
        <Table.Summary fixed>
            <Table.Summary.Row style={{ backgroundColor: '#fafafa' }}>
                <Table.Summary.Cell index={0} colSpan={colSpan} align="right">
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 8 }}>
                        {summary.appointmentSummaries.map((s, i) => (
                            <div key={i} style={{ display: 'grid', gridTemplateColumns: 'auto auto', columnGap: 16, rowGap: 2, alignItems: 'baseline' }}>
                                <Text type="secondary" style={{ fontSize: 12, textAlign: 'left' }}>{t('Total')}</Text>
                                <Text strong style={{ textAlign: 'right' }}>{formatPrice(s.totalPrice, { currency: s.currency })}</Text>

                                <Text type="secondary" style={{ fontSize: 12, textAlign: 'left' }}>{t('Paid Amount')}</Text>
                                <a onClick={openPaymentSummaryByMethod} style={{ fontWeight: 600, color: 'inherit', textAlign: 'right' }}>
                                    {formatPrice(s.totalPaid, { currency: s.currency })}
                                </a>

                                <Text type="secondary" style={{ fontSize: 12, textAlign: 'left' }}>{t('Remaining Debt')}</Text>
                                <Text strong style={{ fontSize: 14, textAlign: 'right', color: s.total > 0 ? '#cf1322' : '#389e0d' }}>
                                    {formatPrice(s.total, { currency: s.currency })}
                                </Text>
                            </div>
                        ))}
                    </div>
                </Table.Summary.Cell>
            </Table.Summary.Row>
        </Table.Summary>
    )
}
